/**
 * syncStatusZeit — Zeit-Formatierung fuer die Sync-Status-Leiste (Quick-Task 260831-nnv).
 *
 * Pure functions, getrennt von der Komponente, damit sie ohne React/DOM in Vitest
 * laufen (Konvention wie dashboardStatsMapper / groupOrders / sectionQueryBuilder).
 *
 * `jetzt` ist ueberall injizierbar — sonst waeren die Tests von der Systemzeit
 * abhaengig und die Grenzwerte (59 Min vs. 60 Min) nicht pruefbar.
 */

/** Relative Zeit, z.B. "vor 3 Min", "vor 2 Std", "vor 5 Tg". Ohne Zeitstempel: "nie". */
export function formatRelativeZeit(iso: string | null, jetzt: number = Date.now()): string {
  if (!iso) return 'nie';
  const ms = new Date(iso).getTime();
  if (Number.isNaN(ms)) return 'nie';
  const diffMs = jetzt - ms;
  if (diffMs < 0) return 'gerade eben';
  const minuten = Math.floor(diffMs / 60_000);
  if (minuten < 1) return 'gerade eben';
  if (minuten < 60) return `vor ${minuten} Min`;
  const stunden = Math.floor(minuten / 60);
  if (stunden < 24) return `vor ${stunden} Std`;
  return `vor ${Math.floor(stunden / 24)} Tg`;
}

/** Fuer laufende Flows: "läuft seit X Min". Ohne Startzeit nur "läuft". */
export function formatLaeuftSeit(iso: string | null, jetzt: number = Date.now()): string {
  if (!iso) return 'läuft';
  const ms = new Date(iso).getTime();
  if (Number.isNaN(ms)) return 'läuft';
  const minuten = Math.max(0, Math.floor((jetzt - ms) / 60_000));
  return `läuft seit ${minuten} Min`;
}

/** Voller Zeitstempel fuer das title-Attribut (Tooltip). Ohne Wert: leerer String. */
export function formatVollerZeitstempel(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('de-DE');
}
